import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import {environment} from '../../../../../../environments/environment';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class AgencyService {

  headers: Headers;
  url = environment.qrcode_url;
  url2 = environment.qrcode_url_aps

  constructor(
    private http: Http
  ) {
    const token = localStorage.getItem('Access-Token');
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }
  getList(query?: any): Observable<any> {
    return this.http.get(`${this.url}/agencies`, { headers: this.headers, params: query }).map(res => {
      return res.json();
    });
  }
  getDetail(id?: string): Observable<any> {
    return this.http.get(`${this.url}/agencies/${id}`, { headers: this.headers }).map(res => {
      return res.json();
    });
  }
  stopCooperate(id?: string): Observable<any> {
    return this.http.put(`${this.url}/agencies/${id}/stop_cooperation`, {}, { headers: this.headers }).map(res => {
      return res.json();
    }).catch((error: any) => {
      throw error.json();
    });
  }
  openCooperate(id?: string): Observable<any> {
    return this.http.put(`${this.url}/agencies/${id}/open_cooperation`, {}, { headers: this.headers }).map(res => {
      return res.json();
    }).catch((error: any) => {
      throw error.json();
    });
  }
  statistics(id?: string): Observable<any> {
    return this.http.get(`${this.url}/agencies/${id}/statistics/v2`, { headers: this.headers }).map(res => {
      return res.json();
    });
  }
  getListStampOfAgency(query?: any, id?: string, type?: string): Observable<any> {
    return this.http.get(`${this.url}/agencies/${id}/${type}/stamp`, { headers: this.headers, params: query }).map(res => {
      return res.json();
    });
  }
  getListStampSaleOut(query?: any, id?: string): Observable<any> {
    return this.http.get(`${this.url}/agencies/${id}/stamp/sale-out`, { headers: this.headers, params: query }).map(res => {
      return res.json();
    });
  }
  getListAccountIcheck(query?: any): Observable<any> {
    return this.http.get(`${this.url}/agencies/account/link/search`, { headers: this.headers, params: query }).map(res => {
      return res.json();
    });
  }
  create(body?: any): Observable<any> {
    return this.http.post(`${this.url}/agencies`, body, { headers: this.headers }).map(res => {
      return res.json();
    }).catch((error: any) => {
      throw error.json();
    });
  }
  update(body?: any, id?: string): Observable<any> {
    return this.http.put(`${this.url}/agencies/${id}`, body, { headers: this.headers }).map(res => {
      return res.json();
    }).catch((error: any) => {
      throw error.json();
    });
  }
  getAccountIcheckById(id?: string): Observable<any> {
    return this.http.get(`${this.url}/agencies/account/link/${id}`, { headers: this.headers }).map(res => {
      return res.json();
    });
  }
  returnStamp(body?: any) {
    return this.http.post(`${this.url}/transfer/stamp/take_back`, body, { headers: this.headers }).map(res => {
      return res.json();
    }).catch((error: any) => {
      throw error.json();
    });
  }
  // tuanba:17/5/20222: cấu hình ghi nhậ bán ra

  getSaleOutSetting() {
    return this.http.get(`${this.url}/sale-out-setting`, { headers: this.headers }).map(res => {
      return res.json();
    });
  }

  saleOutSetting(body?: any) {
    return this.http.post(`${this.url}/sale-out-setting`, body, {headers: this.headers}).map(res => {
      return res.json();
    }).catch((error: any) => {
      throw error.json();
    });
  }

  // tuanba: 17/08/2022: Cấu hình tồn kho
  getListInventoryProduct(query?: any, id?: string) {
    return this.http.get(`${this.url}/statistic/distribution/agencies/${id}/product`, {headers: this.headers, params: query}).map(res => {
      return res.json();
    });
  }

  getListInventoryBatch(query?: any, id?: string) {
    return this.http.get(`${this.url}/statistic/distribution/agencies/${id}/batch`, {headers: this.headers, params: query}).map(res => {
      return res.json();
    });
  }

  /*Tuanba sellout: 15/12/2022 */
  validateAccountSaleOut(query?: any, id?: string) {
    return this.http.get(`${this.url2}/sellout/link`, {headers: this.headers, params: query}).map(res => {
      return res.json();
    });
  }
  validatePhoneNumber(body?: any) {
    return this.http.post(`${this.url}/agencies/validate_create_or_update`, body, {headers: this.headers}).map(res => {
      return res.json();
    }).catch((error: any) => {
      throw error.json();
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/agencyListing/services/agency.service.ts